var map = {
	"./A.png": "df66",
	"./B.png": "711f",
	"./C.png": "0228",
	"./D.png": "8bc9",
	"./E.png": "4859",
	"./Eye.svg": "46f2",
	"./Group 323.svg": "47b6",
	"./Search.svg": "2678",
	"./Trash.png": "a781",
	"./account.png": "db6d",
	"./atras.png": "51a7",
	"./atras.svg": "bc6e",
	"./avatar.jpg": "92ef",
	"./avatar2.jpg": "d339",
	"./back.svg": "c9a6",
	"./back2.svg": "c1da",
	"./build.png": "55cd",
	"./build2.png": "fdb8",
	"./caret.png": "e1d6",
	"./check.png": "722d",
	"./checkAccount.png": "af3b",
	"./checkdatos.png": "d0a5",
	"./colegio.svg": "8740",
	"./copy.png": "8c7b",
	"./dashboard-1.png": "2fd7",
	"./dashboard-2.png": "db6b",
	"./dashboard-3.png": "4be1",
	"./dashboard-4.png": "d4b0",
	"./dashboard-5.png": "3c73",
	"./dashboard.png": "a623",
	"./dashboard1.png": "c9f7",
	"./dashboard2.png": "0107",
	"./descarga.svg": "42cd",
	"./dos.svg": "a61b",
	"./eddit.png": "895e",
	"./edit.png": "8170",
	"./edit2.png": "c48e",
	"./editinfo.png": "44e1",
	"./education1.png": "989a",
	"./email.png": "d502",
	"./erase1.png": "3ff8",
	"./erase2.png": "0e69",
	"./eraseinfo.png": "c69e",
	"./error.svg": "7314",
	"./error_back.png": "911c",
	"./excel.svg": "75fe",
	"./eye.png": "a33f",
	"./help.png": "dfdd",
	"./help2.png": "40f1",
	"./home.jpg": "95fc",
	"./keys.png": "8ac4",
	"./keys2.png": "e41e",
	"./logo-default.jpg": "0d26",
	"./logo-soporte.svg": "c919",
	"./logo.png": "9d64",
	"./next.png": "0f66",
	"./next.svg": "35fe",
	"./notes.png": "61c1",
	"./notes1.png": "0384",
	"./notes2.png": "cc5e",
	"./pdf.svg": "5fe9",
	"./plus.png": "cf27",
	"./reportes.png": "b017",
	"./reportes2.png": "9fac",
	"./result-icon.png": "559b",
	"./result-icon2.png": "ccdb",
	"./resultado.svg": "a52c",
	"./resultado2.svg": "7ee0",
	"./save.png": "bd1a",
	"./simulacro.png": "847d",
	"./soporte.svg": "113a",
	"./soporte2.svg": "78c9",
	"./tres.svg": "9e93",
	"./ucspadmin.png": "867f",
	"./university-g.png": "7f9f",
	"./university1.png": "9660",
	"./university2.png": "0577",
	"./uno.svg": "758b",
	"./xls.png": "ffdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";